import React from 'react';
import { MessageSquare, UserPlus, CheckSquare, Edit, Plus, FileText } from 'lucide-react';
import { Avatar } from '../ui/Avatar';
import { Activity } from '../../types/workspace';
interface ActivityFeedProps {
  activities: Activity[];
}
export function ActivityFeed({
  activities
}: ActivityFeedProps) {
  if (activities.length === 0) {
    return <div className="text-center py-8" data-id="element-50">
        <p className="text-gray-500" data-id="element-51">No activity yet</p>
        <p className="text-gray-500 text-sm mt-1" data-id="element-52">
          Activities will appear here as your team collaborates
        </p>
      </div>;
  }
  const getActivityIcon = (type: string) => {
    switch (type) {
      case 'comment':
        return <MessageSquare size={16} className="text-blue-500" data-id="element-53" />;
      case 'invite':
        return <UserPlus size={16} className="text-purple-500" data-id="element-54" />;
      case 'action':
        return <CheckSquare size={16} className="text-green-500" data-id="element-55" />;
      case 'edit':
        return <Edit size={16} className="text-orange-500" data-id="element-56" />;
      case 'add':
        return <Plus size={16} className="text-indigo-500" data-id="element-57" />;
      case 'decision':
        return <FileText size={16} className="text-red-500" data-id="element-58" />;
      default:
        return <Edit size={16} className="text-gray-500" data-id="element-59" />;
    }
  };
  return <div className="flow-root" data-id="element-60">
      <ul className="-mb-8" data-id="element-61">
        {activities.map((activity, index) => <li key={index} data-id="element-62">
            <div className="relative pb-8" data-id="element-63">
              {index !== activities.length - 1 && <span className="absolute top-5 left-5 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true" data-id="element-64" />}
              <div className="relative flex items-start space-x-3" data-id="element-65">
                <div className="relative" data-id="element-66">
                  <div className="h-10 w-10 rounded-full bg-gray-100 flex items-center justify-center ring-8 ring-white" data-id="element-67">
                    {getActivityIcon(activity.type)}
                  </div>
                </div>
                <div className="min-w-0 flex-1" data-id="element-68">
                  <div data-id="element-69">
                    <div className="text-sm" data-id="element-70">
                      <a href="#" className="font-medium text-gray-900" data-id="element-71">
                        {activity.user.name}
                      </a>
                    </div>
                    <p className="mt-0.5 text-sm text-gray-500" data-id="element-72">
                      {activity.date}
                    </p>
                  </div>
                  <div className="mt-2 text-sm text-gray-700" data-id="element-73">
                    <p data-id="element-74">{activity.description}</p>
                  </div>
                  {activity.target && <div className="mt-2 text-sm text-gray-700 bg-gray-50 p-2 rounded border border-gray-200" data-id="element-75">
                      <p className="font-medium" data-id="element-76">{activity.target.title}</p>
                      {activity.target.description && <p className="text-gray-500" data-id="element-77">
                          {activity.target.description}
                        </p>}
                    </div>}
                </div>
              </div>
            </div>
          </li>)}
      </ul>
    </div>;
}